import {gql} from "@apollo/client";

export const GET_TRANSACTIONS = gql`
query GetTransactions {
    transactions {
         id
         sum
         datetime
         type
         description
         comment
         project {
           id
           name
         }
         receipt {
           id
         }
    }
}
`;

export const GET_PROJECTS = gql`
    query GetProjects {
        projects {
            id
            name
        }
    }
`;